<template>
	<button ref="searchButton" class="search-btn flex w-full items-center" @click="openBox">
		<Icon name="ion:search-outline" :size="16" class="search-btn-icon" />
		<span class="hidden truncate pr-8 md:inline">{{ $t(`common.misc.search_on`) }} justmum</span>
		<span class="pr-8 md:hidden">{{ $t(`common.misc.search`) }}</span>
	</button>
</template>

<script lang="ts" setup>
import { ref } from "vue"
import Icon from "@/components/common/Icon.vue"
import { useSearchDialog } from "@/composables/common/useSearchDialog"

const searchButton = ref<HTMLElement | null>(null)

function openBox() {
	if (searchButton.value) {
		searchButton.value.blur()
	}
	useSearchDialog().open()
}
</script>

<style lang="scss" scoped>
.search-btn {
	border-radius: 50px;
	background-color: var(--bg-body-color);
	gap: 10px;
	height: 32px;
	cursor: pointer;
	padding: 4px 10px;
	outline: none;
	border: none;

	:deep() {
		& > .n-icon {
			opacity: 0.5;
			transition: opacity 0.3s;
		}
	}
	& > span {
		opacity: 0.5;
		font-size: 14px;
		transition: opacity 0.3s;
	}

	&:hover {
		:deep() {
			& > .n-icon {
				opacity: 0.9;
			}
		}
		& > span {
			opacity: 0.9;
		}
	}
}

.direction-rtl {
	.search-btn {
		padding-right: 10px;
		padding-left: 6px;

		.search-btn-icon {
			transform: rotateY(180deg);
		}
	}
}
</style>
